import { useDispatch, useSelector } from 'react-redux';
import { redirectUrlSelector } from 'src/state/auth/authSelectors';
import { useEffect } from 'react';
import { isSome } from 'fp-ts/Option';
import { PostRedirectAction } from 'src/config/postRedirectAction';
import { useIsLoggedIn } from 'src/common/hooks/useIsLoggedIn';
import { useRegisterForTheEventMutator } from 'src/common/hooks/event/useRegisterForTheEventMutator';
import { snackbarActions } from 'src/state/notification/notificationActions';

export const useRegisterAfterRedirect = (courseId?: number, eventId?: number) => {
  const redirectUrl = useSelector(redirectUrlSelector);
  const { isLoggedIn } = useIsLoggedIn();
  const mutation = useRegisterForTheEventMutator();
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      isLoggedIn &&
      isSome(redirectUrl) &&
      PostRedirectAction.CourseEventRegister === redirectUrl.value.action &&
      courseId &&
      eventId
    ) {
      mutation.mutateAsync({ courseId, eventId }).then(() => {
        dispatch(
          snackbarActions.enqueueSnackbar({
            message: 'Zgłoszenie zostało wysłane',
            options: { variant: 'success' },
          }),
        );
      });
    }
  }, [redirectUrl, isLoggedIn, courseId, eventId]);

  return mutation;
};
